import type { LucideIcon } from "lucide-react"
import { Calculator, MapPinned } from "lucide-react"

export const HOME_LOGO_CLASS_INLINE =
  "h-[100px] w-auto max-w-[280px] object-contain"

export const HOME_LOGO_CLASS_CARD =
  "h-[100px] w-auto max-w-[280px] object-contain"

export interface ProductHighlightItem {
  id: string
  title: string
  description: string
  icon: LucideIcon
  badge?: string
}

export const PRODUCT_HIGHLIGHTS: ProductHighlightItem[] = [
  {
    id: "beva",
    title: "Calcul BEVA",
    description:
      "Calculez instantanément la valeur de vos arbres avec le BEVA ! Après l'inventaire de l'arbre, notre outil génère automatiquement une estimation précise de sa valeur selon la méthode BEVA. Une solution rapide, fiable et professionnelle pour valoriser votre patrimoine arboré en quelques clics.",
    icon: Calculator,
    badge: "Valeur de l'arbre",
  },
  {
    id: "geomatique",
    title: "Calcul géomatique des espaces boisés",
    description:
      "Optimisez la gestion de vos zones forestières grâce à la précision de la géomatique ! Analyse des surfaces, cartographie intelligente, données fiables et résultats rapides : prenez des décisions éclairées pour vos projets environnementaux, fonciers et d'aménagement.",
    icon: MapPinned,
    badge: "Espaces boisés",
  },
]

export const DENDROMAP_MARKETING_HEADLINE =
  "DENDROMAP ! le meilleur outil du marché pour une gestion du patrimoine arboré plus performante, plus simple et plus intelligente."

export const DENDROMAP_MARKETING_PARAGRAPHS: string[] = [
  "Référence incontournable du secteur, DENDROMAP s'impose aujourd'hui comme le meilleur outil du marché pour piloter et valoriser votre patrimoine arboré. Grâce à sa technologie innovante, sa cartographie avancée et son suivi ultraprécis, vous centralisez toutes vos données et optimisez chaque intervention avec efficacité.",
  "Pensé pour les professionnels les plus exigeants, DENDROMAP transforme la gestion arboricole en une expérience fluide, rapide et stratégique.",
  "Plus qu'un logiciel, un véritable allié pour une gestion durable, moderne et maîtrisée de vos arbres.",
]
